import axios, { AxiosError, AxiosResponse } from "axios";

import history from "./browserHistory";
import { objectToQueryString } from "./url";
import { getStoreStorage } from "../shared/utils/storage";





type PropT = {
  [x: string]: any;
};




const getDefaults = async () => {
  const config: any = {};
  
  return {
    baseURL: config.apiEndpoint,
    headers: (accessToken: any) => {
      return {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: accessToken || undefined,
      };
    },
    error: {
      code: "INTERNAL_ERROR",
      message: "Something went wrong. Please contact our support.",
      status: 503,
      data: {},
    },
  };
};


const api = async(
  method: string,
  url?: string,
  variables?: any,
  headers = {},
  cache = true
) => {
  const accessToken: any = await getStoreStorage("accessToken");

  const defaults= await getDefaults();

  return new Promise((resolve, reject) => {
    axios({
      url: `${defaults.baseURL}${url}`,
      method,
      headers: {
        ...defaults.headers(accessToken),
        ...headers,
      },
      params: method === "get" ? variables : undefined,
      data:
        method !== "get"
          ? variables
          : undefined,
      paramsSerializer: objectToQueryString,
    } as PropT).then(
      (response: any) => {
        resolve(response);
      },
      (error: any) => {
        if (error?.code === "ERR_BAD_RESPONSE") {
          reject({
            code: 500,
            status: false,
            message: "System error. Kindly report via our feedback channel.",
          });
        }
        
     
        if (error.response) {
          if (error?.response?.status === "404") {
            reject({
              code: 404,
              status: false,
              message:
                "System resource not found or dropped. Kindly report via our feedback channel.",
            });
          }
          
          if (
            ["INVALID_TOKEN", "token_not_valid"].includes(error.code) ||
            ([401].includes(error.response.status) &&
              error?.response?.data?.message !== "Invalid credentials")
          ) {
            history.push("/login");
          } else {
            reject(error);
          }
        } else {
          reject(defaults.error);
        }
      }
    );
  });
};

const optimisticUpdate = async (
  url: string,
  { updatedFields, currentFields, setLocalData }: PropT
) => {
  try {
    setLocalData(updatedFields);
    await api("put", url, updatedFields);
  } catch (error) {
    setLocalData(currentFields);
  }
};

export default {
  get: (...args: any) => api("get", ...args),
  post: (...args: any) => api("post", ...args),
  put: (...args: any) => api("put", ...args),
  patch: (...args: any) => api("patch", ...args),
  delete: (...args: any) => api("delete", ...args),
  optimisticUpdate,
} as PropT;
